import { Track } from "../../AudioManager";
import { SetStyles, Point, Size, CreateElement, LogGroup} from "../../MyHelpers";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { Settings } from "../../Settings";
import { CometDefault } from "./CometDefault";
export class CometPurple extends CometDefault {
    protected override topCenterOffset: number = 0.42;
    protected override bottomCenterOffset: number= 0.197;
    protected override rotateOrigin: string = "50% 87%";
    public override PrepareResources(resourceManager: IWriteOnlyResourceManager): void {
        resourceManager.AddGlobal(new SpriteResource(Settings.ResourcesFolder + "multigame/slot/common/resources/HoldAndSpin/resources/cometShortPurple", ResourceIdentifier.Global.Add("BonusWinShow").Add("Commet"), true, LogGroup.Global.Add("BonusWinShow").Add("Commet"), true))
        this.audio.AddTrack(new Track(Settings.ResourcesFolder +  "multigame/slot/common/resources/HoldAndSpin/resources//tracks/cometShortPurple" + Settings.audioFormat, this.resid.ScopedResourceName("comet")));
    }
}